import { createStoreWithSelector } from '@utils/zustand/createStoreWithSelector';
import { createUseStore } from '@utils/zustand/createUseStore';

export const connectionStore = createStoreWithSelector<{
  isConnected: boolean;
  setIsConnected: (connected: boolean) => void;
}>()((set) => ({
  isConnected: true,
  setIsConnected: (connected) => set({ isConnected: connected })
}));

export const useConnectionStore = createUseStore(connectionStore);
export const setIsConnected = (connected: boolean) =>
  connectionStore.getState().setIsConnected(connected);

export const offlineUnsyncedDocumentsStore = createStoreWithSelector<{}>()(() => ({}));

export const useOfflineUnsyncedDocumentsStore = createUseStore(offlineUnsyncedDocumentsStore);

export const offlineStore = createStoreWithSelector<{
  syncing: boolean;
  setSyncing: (syncing: boolean) => void;
}>()((set) => ({
  syncing: false,
  setSyncing: (syncing) => set({ syncing })
}));

export const useOfflineStore = createUseStore(offlineStore);
